import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { initEmailJS } from './services/emailService';
import { Header, Footer, BackToTop } from './components';
import { Home, Profile, History, Philosophy, IotCctv, Solar, ArchitecturalConstruction, LandscapeGarden, News, NewsDetail, Contact, Projects, Jobs } from './pages';
import JobDetail from './pages/JobDetail';
import AdminLayout from './components/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProjects from './pages/admin/AdminProjects';
import AdminProjectCreate from './pages/admin/AdminProjectCreate';
import AdminProjectEdit from './pages/admin/AdminProjectEdit';
import AdminNews from './pages/admin/AdminNews';
import AdminNewsCreate from './pages/admin/AdminNewsCreate';
import AdminNewsEdit from './pages/admin/AdminNewsEdit';
import AdminJobs from './pages/admin/AdminJobs';
import AdminJobCreate from './pages/admin/AdminJobCreate';
import AdminJobEdit from './pages/admin/AdminJobEdit';
import AdminCategories from './pages/admin/AdminCategories';

// Component để kiểm tra có phải admin route không
const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    // Initialize EmailJS when app starts
    initEmailJS();
  }, []);

  return (
    <div className="App">
      {!isAdminRoute && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us/profile" element={<Profile />} />
          <Route path="/about-us/history" element={<History />} />
          <Route path="/about-us/philosophy" element={<Philosophy />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/iotcctv" element={<IotCctv />} />
          <Route path="/projects/solar" element={<Solar />} />
          <Route path="/projects/architecturalconstruction" element={<ArchitecturalConstruction />} />
          <Route path="/projects/landscapegarden" element={<LandscapeGarden />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:identifier" element={<JobDetail />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="projects/create" element={<AdminProjectCreate />} />
            <Route path="projects/edit/:id" element={<AdminProjectEdit />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="news/create" element={<AdminNewsCreate />} />
            <Route path="news/edit/:id" element={<AdminNewsEdit />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="jobs/create" element={<AdminJobCreate />} />
            <Route path="jobs/edit/:id" element={<AdminJobEdit />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
          </Route>
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <BackToTop />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
